<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">管理</el-breadcrumb-item>
      <el-breadcrumb-item>活动报名管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
     
      <el-table :data="listData" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column
          label="id"
          prop="id"
          align="center"
          width="50px"
        ></el-table-column>
        <el-table-column
          label="活动标题"
          prop="title"
          align="center"
          width="150px"
        ></el-table-column>
        <el-table-column
          label="报名人信息"
          prop="desc"
          align="center"
          width="150px"
        >
        <template slot-scope="scope">
            <div>家长：{{ scope.row.name }}</div>
            <div>学生：{{ scope.row.s_name }}</div>
            <div>学生：{{ scope.row.phone }}</div>
          </template>
      </el-table-column>
      <el-table-column
          label="报名时间"
          prop="create_at"
          width="130px"
        ></el-table-column>
        <el-table-column
          label="备注"
          prop="beizhu"
          width="200px"
        ></el-table-column>


        <el-table-column label="操作" v-if="canLook == 1" width="180px">
          <template slot-scope="scope">
            <el-tooltip
              :enterable="false"
              content="备注"
              effect="dark"
              placement="top"
            >
              <el-button
                @click="edit(scope.row.id)"
                icon="el-icon-edit"
                size="mini"
                type="primary"
              >备注</el-button>
            </el-tooltip> 
            <el-button
                @click="deleteById(scope.row.id)"
                icon="el-icon-edit"
                size="mini"
                type="danger"
              >删除</el-button>


          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

   

    <!-- 编辑对话框 -->
    <el-dialog
      :visible.sync="editDialogVisible"
      @close="editFormClose"
      title="添加备注"
      width="60%"
    >
      <el-form
        :model="editForm"
        :rules="editFormRules"
        label-width="80px"
        ref="editFormRef"
      >
        <el-form-item label="备注" prop="beizhu">
          <el-input v-model="editForm.beizhu"></el-input>
        </el-form-item>
        
      </el-form>
      <span class="dialog-footer" slot="footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button @click="sureToedit()" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isshow: true, //是否显示
      canLook: 1,
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 10,
      },
      total: 0,
      listData: [],
  

      editForm: {
        id: "",
        beizhu: "",
      },

      // 编辑用户弹框显示
      editDialogVisible: false,
      // 编辑用户的表单校验
      editFormRules: {
        beizhu: [{ required: true, message: "请输入备注", trigger: "blur" }], 
      },
    };
  },
  created() {
    this.getData();
  },

  methods: {
 
 
    async getData() {
      if (window.sessionStorage.getItem("pathCanLook") == 2) {
        //仅查看
        this.canLook = 2;
      }
      const { data: res } = await this.$http.get("/admin/activityApply/getList", {
        params: this.queryInfo,
      });
      console.log(res.result);
      if (res.code != 200) return this.$message.error("获取数据失败");
      this.listData = res.result.list;
      this.total = res.result.count;
    },
 
    // 编辑按钮点击
    async edit(aId) {
      const { data: res } = await this.$http.get("/admin/activityApply/detail", {
        params: {
          id: aId,
        },
      });
      console.log(res);
      if (res.code != 200) {
        return this.$message.error("获取信息失败");
      }
      this.editForm = res.result;
      this.editDialogVisible = true;
    },

    editFormClose() {
      this.editDialogVisible = false;
    },

    // 编辑确认
    sureToedit() {
      this.$refs.editFormRef.validate(async (field) => {
        if (!field) return;
        const { data: res } = await this.$http.post(
          "/admin/activityApply/editInfo",
          this.editForm
        );
        if (res.code != 200) {
          return this.$message.error("编辑失败");
        }
        this.$message.success("编辑成功");
        this.editDialogVisible = false;
        this.getData();
      });
    },

    //  删除
    async deleteById(id) {
      console.log(id);
      const result = await this.$confirm(
        "将永久删除该数据, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      console.log(result);
      if (result == "confirm") {
        const { data: res } = await this.$http.post(
          "/admin/activityApply/delete",
          {
            id: id,
          }
        );
        if (res.code != 200) {
          return this.$message.error("删除失败");
        }
        this.$message.success("删除成功");
        this.getData();
      } else {
        return this.$message.info("删除已取消");
      }
    },

   

    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.pagesize = newSize;
      this.getList();
    },

    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.queryInfo.pagenum = newPage;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}
</style>
